import React from 'react';
import { dateFns } from '@core/helpers';

export function WidgetTime ({ date, format = 'HH:mm' }) {
    return (<span>{dateFns.format(date, format)}</span>);
}

// Set display names for debugging.
if (process.env.NODE_ENV !== 'production') {
    WidgetTime.displayName = 'WidgetTime';
}
